import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { 
    activeTab: { type: String, default: "branding" }
  }

  connect() {
    this.showTab(this.activeTabValue)
  }

  switch(event) {
    event.preventDefault()
    const tabId = event.currentTarget.dataset.tab
    this.activeTabValue = tabId
    this.showTab(tabId)
    
    // Update hidden field for form submission
    const activeTabInput = document.getElementById('active_tab')
    if (activeTabInput) {
      activeTabInput.value = tabId
    }
    
    // Update URL hash without scrolling
    history.replaceState(null, null, `#${tabId}`)
  }

  showTab(tabId) {
    // Update tab buttons
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === tabId
      tab.classList.toggle("bg-white", isActive)
      tab.classList.toggle("text-foreground", isActive)
      tab.classList.toggle("shadow-sm", isActive)
      tab.classList.toggle("font-medium", isActive)
      tab.classList.toggle("text-muted-foreground", !isActive)
      tab.classList.toggle("hover:text-foreground", !isActive)
      tab.classList.toggle("hover:bg-white/50", !isActive)
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.panel === tabId
      panel.classList.toggle("hidden", !isActive)
    })
  }

  // Handle browser back/forward
  hashChanged() {
    const hash = window.location.hash.slice(1)
    if (hash && this.tabTargets.some(t => t.dataset.tab === hash)) {
      this.showTab(hash)
    }
  }
}
